// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"f123bb3f","434":"8af16341","787":"adae625b"}[chunkId] + ".chunk.js";
};